export default {
  url_r: "/api/mod/share.do",
  title: "", // 分享标题
  desc: "", // 分享描述
  link: "", // 分享链接
  imgUrl: "", // 分享图标
  type: "link", // 分享类型,music、video或link，不填默认为link
  dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
  shareSuccess() {
    console.log("分享成功！");
  },
  shareCancel() {
    console.log("取消分享！");
  },
  init(param) {
    this.config();
    this.title = param.title;
    this.desc = param.desc;
    this.link = param.link;
    this.imgUrl = param.imgUrl;
    if (param.shareSuccess) {
      console.log("分享成功！");
      this.shareSuccess = param.shareSuccess;
    }
    if (param.shareCancel) {
      console.log("取消分享！");
      this.shareCancel = param.shareCancel;
    }
    wx.checkJsApi({
      jsApiList: [
        "getLocation",
        "updateTimelineShareData",
        "updateAppMessageShareData",
        "onMenuShareWeibo"
      ],
      success(res) {
        console.log(JSON.stringify(res));
      },
      error() {
        console.log("check失败...");
      }
    });
    wx.ready(() => {
      // “分享到朋友圈”及“分享到QQ空间”
      wx.updateTimelineShareData({
        title: param.title, // 分享标题
        link: param.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: param.imgUrl, // 分享图标
        success() {
          // 用户确认分享后执行的回调函数
          console.log("确认分享到朋友圈...");
        }
      });
      // “分享给朋友”及“分享到QQ”
      wx.updateAppMessageShareData({
        title: param.title, // 分享标题
        desc: param.desc, // 分享描述
        link: param.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: param.imgUrl, // 分享图标
        success() {
          // 用户确认分享后执行的回调函数
          console.log("确认分享到朋友...");
        }
      });
      // 分享到腾讯微博
      wx.onMenuShareWeibo({
        title: param.title, // 分享标题
        desc: param.desc, // 分享描述
        link: param.link, // 分享链接
        imgUrl: param.imgUrl, // 分享图标
        success() {
          // 用户确认分享后执行的回调函数
          console.log("确认分享到腾讯微博...");
        }
      });
    });
  }, // 微信配置初始化
  config() {
    $.ajax({
      type: "GET",
      url: this.url_r,
      dataType: "json",
      success(config) {
        wx.config({
          debug: false,
          appId: config.appId,
          timestamp: config.timestamp,
          nonceStr: config.nonceStr,
          signature: config.signature,
          jsApiList: [
            // 所有要调用的 API 都要加到这个列表中
            "checkJsApi",
            "updateTimelineShareData",
            "updateAppMessageShareData",
            "onMenuShareWeibo",
            "scanQRCode"
          ]
        });
      },
      error() {
        console.log("微信config失败...");
      }
    });
  }
};
